/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResumeSubscriptionRequest = {
  /**
   * The unique identifier of the subscription
   */
  id: string;
};

/** @internal */
export const ResumeSubscriptionRequest$inboundSchema: z.ZodType<
  ResumeSubscriptionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});
/** @internal */
export type ResumeSubscriptionRequest$Outbound = {
  id: string;
};

/** @internal */
export const ResumeSubscriptionRequest$outboundSchema: z.ZodType<
  ResumeSubscriptionRequest$Outbound,
  z.ZodTypeDef,
  ResumeSubscriptionRequest
> = z.object({
  id: z.string(),
});

export function resumeSubscriptionRequestToJSON(
  resumeSubscriptionRequest: ResumeSubscriptionRequest,
): string {
  return JSON.stringify(
    ResumeSubscriptionRequest$outboundSchema.parse(resumeSubscriptionRequest),
  );
}
export function resumeSubscriptionRequestFromJSON(
  jsonString: string,
): SafeParseResult<ResumeSubscriptionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResumeSubscriptionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResumeSubscriptionRequest' from JSON`,
  );
}
